import { v4 as uuidV4 } from 'uuid';

import { WorkflowConfig, WorkflowStepConfig } from '~/data/workflows/types';
import { WorkflowRoles } from '~/scenes/AdminModule/components/Views/WorkflowsConfigurationView/data';

export const getInitialWorkflowConfig = (): WorkflowConfig => {
  const emptyStepConfig: WorkflowStepConfig = {
    roleNames: [],
  };

  return {
    id: uuidV4(),
    processType: '',
    unitId: 0,
    workflow: {
      initiators: emptyStepConfig,
      approvalSteps: [],
      closer: {
        roleNames: [WorkflowRoles.FINAL_APPROVER],
      },
      overseer: emptyStepConfig,
      administrator: {
        roleNames: [WorkflowRoles.HR_ADMIN],
      },
    },
  };
};
